(function() {
  'use strict';

  /* ── CUSTOM CURSOR ── */
  function initCursor() {
    if (window.matchMedia('(hover: none)').matches) return;

    var dot  = document.createElement('div');
    var ring = document.createElement('div');
    dot.id  = 'ev-cursor';
    ring.id = 'ev-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var mouseX = 0, mouseY = 0;
    var ringX  = 0, ringY  = 0;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = mouseX + 'px';
      dot.style.top  = mouseY + 'px';
    }, { passive: true });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.15;
      ringY += (mouseY - ringY) * 0.15;
      ring.style.left = ringX + 'px';
      ring.style.top  = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    var interactives = 'a, button, [role="button"], input, .ev-option, .ev-prod-card';

    document.addEventListener('mouseover', function(e) {
      if (e.target.closest(interactives)) {
        dot.style.width      = '10px';
        dot.style.height     = '10px';
        dot.style.background = '#C4622D';
        ring.style.width     = '48px';
        ring.style.height    = '48px';
      }
    });

    document.addEventListener('mouseout', function(e) {
      if (e.target.closest(interactives)) {
        dot.style.width      = '';
        dot.style.height     = '';
        dot.style.background = '';
        ring.style.width     = '';
        ring.style.height    = '';
      }
    });
  }

  /* ── SCROLL ANIMATIONS ── */
  function initScrollAnimations() {
    var els = document.querySelectorAll('.ev-animate');
    if (!els.length) return;

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function(el) { obs.observe(el); });
  }

  /* ── HEADER SCROLL ── */
  function initHeaderScroll() {
    var header = document.getElementById('ev-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ── SMOOTH ANCHOR SCROLL ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── CART COUNT ── */
  function syncCartCount() {
    var el = document.getElementById('ev-cart-count');
    if (!el) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      })
      .catch(function() {});
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    initCursor();
    initScrollAnimations();
    initHeaderScroll();
    initSmoothScroll();
    syncCartCount();
  });

})();